import { Session } from '/app/utils/auth';
import { computed } from 'vue';
import { hardNavigate } from '/app/utils/navigation';

export const useShadowMode = () => {
    const hasShadowUser = computed(() => Session.isShadow());

    const startShadowMode = (token) => {
        Session.startShadow(token);
    }

    const stopShadowMode = () => {
        if (!hasShadowUser.value) {
            return;
        }

        Session.stopShadow();

        hardNavigate('/');
    }

    return {
        hasShadowUser,
        startShadowMode,
        stopShadowMode,
    }
}

export const useStaffMode = () => {
    const hasStaffUser = computed(() => Session.isStaff());

    const startStaffMode = (token) => {
        Session.startStaff(token);

        hardNavigate('/me/my-dashboard?token=' + encodeURIComponent(token) + '&mode=staff');
    }

    const stopStaffMode = () => {
        if (!hasStaffUser.value) {
            return;
        }

        Session.stopStaff();

        hardNavigate('/');
    }

    return {
        hasStaffUser,
        startStaffMode,
        stopStaffMode,
    }
}